import { Alert, Collapse } from '@mui/material';
import { useEffect } from 'react';

export default function GenAlert({ children, open, ...props }) {
  useEffect(() => {
    if (!props.onClose || !open) return () => {};

    const timeout = setTimeout(() => {
      props.onClose();
    }, 3000);

    return () => clearTimeout(timeout);
  });
  return (
    <Collapse in={open}>
      <Alert {...props}>{children}</Alert>
    </Collapse>
  );
}
